import styled from "styled-components"

export const ErrorImg = styled.img`
  width: 100px;
  height: 100px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: auto;
    height: auto;
  `}
`
